export default "__VITE_ASSET__31cb25b5__"